import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RequestLoaderService {

    private _requests$: BehaviorSubject<string[]> = new BehaviorSubject([]);
    public requests$: Observable<string[]> = this._requests$.asObservable();

    constructor() { }

    public add(url: string): void {
        const regex = /http(s)?/g; // show animation only for external api calls
        if (regex.test(url)) {
            this._requests$.next([...this._requests$.value, url]);
        }
    }

    public remove(url: string): void {
        this._requests$.next(this._requests$.value.filter(el => !url.includes(el)));
    }

}
